import React, { useMemo, FC } from 'react';
import { Game } from '@/entities/game';
import { useGameAccessCheck } from '@/shared/hooks/useGameAccessCheck';
import { WishlistToggle } from '@/features/wishlist/ui/wishlist-toggle';

export interface GameType {
  id: number;
  title: string;
  pageTitle?: string;
  type: string;
  filters?: string[] | null;
  providerId: string;
  providerName: string;
  imageUrl?: string;
  videoUrl?: string;
  minBet?: number;
}

interface ConditionalWrapperGameProps {
  handleClickGame: (game: GameType) => void;
  game: GameType;
  hasScroll: boolean;
  activeBonusId?: number | null;
  priority?: boolean;
}

export const ConditionalWrapperGame: FC<ConditionalWrapperGameProps> =
  React.memo(
    ({ handleClickGame, game, hasScroll, activeBonusId, priority }) => {
      const accessHelpers = useGameAccessCheck();

      const handleView = (e: React.MouseEvent<HTMLDivElement>) => {
        // if (canOpenGame) {
        if (e.target instanceof Element && e.target.closest('a')) {
          return;
        }

        handleClickGame(game);
        // }
      };

      const wishlistToggle = useMemo(
        () => <WishlistToggle gameId={game.id} title={game.title} />,
        [game.id, game.title]
      );

      return (
        <div
          onClick={handleView}
          className={`game-card-${game?.title}`}
          role="button"
        >
          <Game
            accessHelpers={accessHelpers}
            hasScroll={hasScroll}
            wishlistToggleSlot={wishlistToggle}
            game={game}
            activeBonusId={activeBonusId}
            priority={priority}
          />
        </div>
      );
    }
  );
